interface ExplorerLoadingOverlayProps {
  show: boolean;
  label?: string;
}

export function ExplorerLoadingOverlay({ show, label = 'Loading data...' }: ExplorerLoadingOverlayProps) {
  if (!show) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center rounded-[2rem] bg-white/70 backdrop-blur-[2px]">
      <div className="flex min-w-[240px] flex-col items-center gap-4 rounded-[1.75rem] border border-slate-200 bg-white/95 px-8 py-7 text-center shadow-[0_24px_80px_rgba(15,23,42,0.14)]">
        <div className="relative flex h-20 w-20 items-center justify-center">
          <div className="absolute inset-0 rounded-full border-[5px] border-sky-100 border-t-sky-500 animate-spin" />
          <div className="absolute inset-[10px] rounded-full border-[5px] border-slate-200 border-b-slate-500 animate-spin [animation-direction:reverse] [animation-duration:1.8s]" />
          <div className="h-4 w-4 rounded-full bg-sky-500 shadow-[0_0_18px_rgba(14,165,233,0.55)] animate-pulse" />
        </div>
        <div>
          <div className="text-base font-semibold text-slate-900">{label}</div>
          <div className="mt-1 text-sm text-slate-500">Refreshing the explorer workbench.</div>
        </div>
      </div>
    </div>
  );
}

export default ExplorerLoadingOverlay;